import cx from 'classnames';
import React from 'react';
import styles from './stepper.module.scss';
import { StepperItem } from './stepper-item/stepper-item';
export const Stepper = ({ currentStep = 0, orientation = 'horizontal', isSequential = true, steps, allStepsCompleted = false, onClick, className = '', ...restProps }) => {
    const stepperWrapper = cx(className, styles.stepperWrapper, {
        [styles.horizontalStepper]: orientation === 'horizontal',
        [styles.verticalStepper]: orientation === 'vertical',
        [styles.sequentialStepper]: isSequential,
    });
    return (React.createElement("div", { className: stepperWrapper, ...restProps },
        React.createElement("div", { className: styles.stepperItemWrapper, role: "tablist" }, steps.map((step, index) => {
            const stepNumber = index;
            const isActive = currentStep === index;
            const isCompleted = index < currentStep || allStepsCompleted;
            const { title } = step;
            return (React.createElement(Stepper.Item, { key: stepNumber, title: title, isActive: isActive, isCompleted: isCompleted, stepNumber: stepNumber, isSequential: isSequential, orientation: orientation, onClick: onClick }));
        }))));
};
Stepper.Item = StepperItem;
//# sourceMappingURL=stepper.js.map